import React, { useState, useEffect } from "react";
import SlidePanel from "../add_customer/SlidePanel";
import { X } from "lucide-react";

const MemberDetails = ({
  id_R,
  id,
  closeMemberDetails,
  isMemberDetailsOpen,
  firstName,
  lastName,
  gender,
  middleName,
  dob,
  identification,
  setFirstName,
  setLastName,
  setMiddleName,
  setIdentification,
  setGender,
  setDob,
  setIsIDModalOpen,
  handleNextButtonClick,
}) => {
  const [isInputsFilled, setIsInputsFilled] = useState(false);

  const handleBackButtonClick = () => {
    setFirstName("");
    setLastName("");
    setMiddleName("");
    setIdentification("");
    setGender("");
    setDob("");
    setIsIDModalOpen(true);
    closeMemberDetails();
  };

  useEffect(() => {
    const areInputsFilled = !!(firstName && lastName && middleName);
    setIsInputsFilled(areInputsFilled);
  }, [firstName, lastName, middleName]);

  return (
    <SlidePanel isOpen={isMemberDetailsOpen} onClose={closeMemberDetails}>
      <div className="relative flex flex-col h-full bg-white rounded-[12px]">
        {/* Close Button */}
        <div
          onClick={closeMemberDetails}
          className="absolute top-0 right-0 cursor-pointer h-[40px] w-[40px] bg-[#FF0000] rounded-tr-[10px] rounded-bl-[20px] flex items-center justify-center z-10"
        >
          <X color="#ffffff" />
        </div>

        <div className="flex flex-col h-full">
          <div className="mt-5 px-5">
            <p className="text-[#000] text-xl font-bold">
              Review Members’ details
            </p>

            <div className="text-[#000] mt-4 text-sm font-normal">
              <p>
                Please upload identity documents to verify the member's identity
                and personal details. Ensure that the provided identity document
                clearly matches the member's face.
              </p>
            </div>
          </div>

          <div className="flex-1 overflow-y-auto px-5 pb-6">
            <div className="flex w-full flex-col mt-5">
              <label
                htmlFor="identification"
                className="mb-1 text-md font-medium text-[#000]"
              >
                Identity document Number
              </label>
              <input
                id="identification"
                type="text"
                value={identification}
                onChange={(e) => setIdentification(e.target.value)}
                className="w-[94%] h-10 px-3 rounded-[4px] bg-[#EAEAEA]"
              />
            </div>

            <div className="flex w-full flex-col mt-5">
              <label
                htmlFor="firstName"
                className="mb-1 text-md font-medium text-[#000]"
              >
                First name
              </label>
              <input
                id="firstName"
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                className="w-[94%] h-10 px-3 rounded-[4px] bg-[#EAEAEA]"
              />
            </div>

            <div className="flex w-full flex-col mt-5">
              <label
                htmlFor="middleName"
                className="mb-1 text-md font-medium text-[#000]"
              >
                Middle name
              </label>
              <input
                id="middleName"
                type="text"
                value={middleName}
                onChange={(e) => setMiddleName(e.target.value)}
                className="w-[94%] h-10 px-3 rounded-[4px] bg-[#EAEAEA]"
              />
            </div>

            <div className="flex w-full flex-col mt-5">
              <label
                htmlFor="lastName"
                className="mb-1 text-md font-medium text-[#000]"
              >
                Last name
              </label>
              <input
                id="lastName"
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                className="w-[94%] h-10 px-3 rounded-[4px] bg-[#EAEAEA]"
              />
            </div>

            <div className="flex w-full flex-col mt-5">
              <label
                htmlFor="dob"
                className="mb-1 text-md font-medium text-[#000]"
              >
                Date of Birth
              </label>
              <input
                id="dob"
                type="date"
                value={dob}
                onChange={(e) => setDob(e?.target?.value)}
                className="w-[94%] h-10 px-3 rounded-[4px] bg-[#EAEAEA]"
              />
            </div>

            <div className="flex w-full flex-col mt-5">
              <label
                htmlFor="gender"
                className="mb-1 text-md font-medium text-[#000]"
              >
                Gender
              </label>
              <select
                id="gender"
                value={gender || ""}
                onChange={(e) => setGender(e?.target?.value)}
                className="w-[94%] h-10 px-3 rounded-[4px] bg-[#EAEAEA]"
              >
                <option value="" disabled>
                  Choose gender
                </option>
                <option value={gender}>{gender}</option>
                {["MALE", "FEMALE"]
                  ?.filter((g) => g !== gender)
                  ?.map((g) => (
                    <option key={g} value={g}>
                      {g?.charAt(0)?.toUpperCase() + g?.slice(1)}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          {/* Footer */}
          <div className="flex justify-between py-3 px-3">
            <button
              onClick={handleBackButtonClick}
              type="button"
              className="text-[#ffff] bg-[#FF5757] hover:bg-[#FF5757] focus:outline-none font-medium rounded-[5px] text-sm px-2 py-2.5 text-center"
            >
              Back, this doesn’t look right repeat
            </button>

            <button
              className={`${
                isInputsFilled
                  ? "bg-[#074073]"
                  : "bg-[#D9D9D9] pointer-events-none"
              } font-medium rounded-[5px] text-[#ffff] text-sm px-2 py-2.5 text-center`}
              disabled={!isInputsFilled}
              onClick={handleNextButtonClick}
            >
              Continue, this looks right, proceed
            </button>
          </div>
        </div>
      </div>
    </SlidePanel>
  );
};

export default MemberDetails;
